<template>
  <v-container>
    <v-data-table
      :items="defaultApps"
      :headers="headers"
    >
    <template slot="items" slot-scope="props">
      <tr style="text-align:left">
        <td>{{props.item.Id}}</td>
        <td>{{props.item.DefaultAmountDue}}</td>
        <td>{{amountPaid(props.item.DefaultPayments)}}</td>
      </tr>
    </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const moduleNameSpace = 'applications'
export default {
  data(){
    return {
      headers: [
        {text: 'ApplicationID', value: 'Id'},
        {text: 'Amount Due', value: 'DefaultAmountDue'},
        {text: 'Amount Paid', value: '', sortable: false},
      ]
    }
  },
  created(){
    this.getDefault()
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getDefault']),
    amountPaid(list){
      let amt = 0
      list.forEach(item => {
        amt += item.AmountPaid
      });
      return amt
    }
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['defaultApps'])
  }
}
</script>

<style>

</style>
